import { apiClient } from './ApiClient'
import { CategorySummary, CategoryInfo, CreateCategoryRequest, UpdateCategoryRequest } from '../types/entities'

export class CategoryService {
  private basePath = '/categories'

  async getCategories(): Promise<CategorySummary[]> {
    return apiClient.get<CategorySummary[]>(this.basePath)
  }

  async getCategory(categoryId: string): Promise<CategoryInfo> {
    return apiClient.get<CategoryInfo>(`${this.basePath}/${categoryId}`)
  }

  async createCategory(request: CreateCategoryRequest): Promise<CategoryInfo> {
    return apiClient.post<CategoryInfo>(this.basePath, request)
  }

  async updateCategory(categoryId: string, request: UpdateCategoryRequest): Promise<CategoryInfo> {
    return apiClient.put<CategoryInfo>(`${this.basePath}/${categoryId}`, request)
  }

  async deleteCategory(categoryId: string): Promise<void> {
    return apiClient.delete<void>(`${this.basePath}/${categoryId}`)
  }
}

export const categoryService = new CategoryService()